module.exports = __webpack_public_path__ + "img/Custom_Slider-Arrow_Left.3a904887.svg";